import React from 'react';
import '../Style/Spinner.css'; // Ensure the CSS file is correctly imported

const Spinner = () => {
  return (
  <div class='loaders'>
  <div class="bounce ball1"></div>
  <div class="bounce ball2"></div>
  <div class="bounce ball3"></div>
  <div class="bounce ball4"></div>
</div>
  );
};

export default Spinner;